import apiClient from './client';

// In dev mode with SKIP_AUTH, replace the 401-redirect interceptor
// to prevent infinite redirect loops when the backend returns 401
if (process.env.REACT_APP_SKIP_AUTH === 'true') {
  // Clear all existing response interceptors (removes the 401 redirect handler)
  const handlers = (apiClient.interceptors.response as any).handlers;
  if (handlers) {
    for (let i = 0; i < handlers.length; i++) {
      apiClient.interceptors.response.eject(i);
    }
  }

  // Add a simple pass-through that doesn't redirect on 401
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
  );
}
